










import { Component, Vue, Ref } from "vue-property-decorator";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";
import { formatKWh } from "@/utils/LocalisationHelper";

@Component({
  components: {
    "base-dialog": BaseDialogComponent,
  },
})
export default class ConfirmMeterReadingComponent extends Vue {
  meterReadingText = "";

  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  resolve?: (value: boolean) => void = undefined;
  reject?: (reason: string) => void = undefined;

  async show(meterReading: number, title: string) {
    this.meterReadingText = formatKWh(this, meterReading);

    this.baseDialogComponent.show({
      title: title,
      styleAsAlertDialog: true,
      positiveButtonText: this.$t("common.confirm").toString(),
      negativeButtonText: this.$t("common.abort").toString(),
    });

    return new Promise<boolean>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  async onSave() {
    this.resolve && this.resolve(true);
  }
}
